import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import AppGrid from './AppGrid';
import BimCatastroApp from '../apps/bim-catastro/App';
import { useRouting } from './useRouting';
import './PortalApp.css';

const PortalApp: React.FC = () => {
  const { currentApp, navigateToApp, navigateToPortal } = useRouting();

  const handleAppSelect = (appId: string) => {
    navigateToApp(appId);
  };

  const handleBackToPortal = () => {
    navigateToPortal();
  };

  // Si hay una app seleccionada, renderizarla
  if (currentApp) {
    switch (currentApp) {
      case 'bim-catastro':
        return (
          <div className="app-container">
            <div className="app-header">
                                  <button className="back-button" onClick={handleBackToPortal}>
                      ← Volver a IFC Tools
                    </button>
              <h2>BIM Catastro</h2>
            </div>
            <div className="app-content">
              <BimCatastroApp />
            </div>
          </div>
        );
      default:
        return (
          <div className="app-not-found">
            <h1>Aplicación no encontrada</h1>
            <p>La aplicación "{currentApp}" no existe.</p>
                                <button onClick={handleBackToPortal}>
                      Volver a IFC Tools
                    </button>
          </div>
        );
    }
  }

  // Renderizar el portal principal
  return (
    <Authenticator>
      {({ signOut, user }) => (
        <div className="portal-app">
          <header className="portal-header">
            <div className="portal-header-content">
                                    <div className="portal-logo">
                        <img src="/assets/voxel3d-logo-cubo.png" alt="IFC Tools Logo" />
                        <h1>IFC Tools</h1>
                      </div>
              
              <div className="portal-user-info">
                <div className="user-details">
                  <span className="user-name">{user?.username || 'Usuario'}</span>
                  <span className="user-email">{user?.signInDetails?.loginId || ''}</span>
                </div>
                <button className="sign-out-button" onClick={signOut}>
                  Cerrar Sesión
                </button>
              </div>
            </div>
          </header>
          
          <main className="portal-main">
            <AppGrid onAppSelect={handleAppSelect} />
          </main>
        </div>
      )}
    </Authenticator>
  );
};

export default PortalApp;
